import { HardDrive } from "lucide-react";
import { formatBytes } from "@/lib/api";

export const StorageMeter = ({ data }) => {
  if (!data) return null;
  const pct = Math.min(100, (data.usado / data.limite) * 100);
  const color = pct >= 90 ? "bg-red-600" : pct >= 75 ? "bg-amber-500" : "bg-[#1f44e0]";
  const fmt = (b) => (b < 1024 ** 2 ? `${(b / 1024).toFixed(0)} KB` : formatBytes(b));
  return (
    <div className="rounded-xl bg-white border border-[#0f2544]/8 p-5 mt-5" data-testid="storage-meter">
      <div className="flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 text-sm font-medium text-[#0f2544]"><HardDrive size={16} /> Almacenamiento de archivos</span>
        <span className="text-sm text-[#4a4a45]" data-testid="storage-used">{fmt(data.usado)} de {formatBytes(data.limite)} · quedan {formatBytes(Math.max(0, data.limite - data.usado))}</span>
      </div>
      <div className="h-2.5 rounded-full bg-[#e7e5df] overflow-hidden mt-3">
        <div className={`h-full ${color} transition-[width] duration-500`} style={{ width: `${Math.max(pct, 0.5)}%` }} />
      </div>
      <p className="text-xs text-[#8a8a83] mt-2">Incluye portadas, fotos, PDF y EPUB subidos.</p>
      {pct >= 80 && <p className="text-xs text-red-600 mt-1" data-testid="storage-warning">Te queda poco espacio: borra archivos que ya no uses antes de subir más.</p>}
    </div>
  );
};
